"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TouchDetector = /** @class */ (function () {
    function TouchDetector() {
        this.touch = true;
        this.lastTouch = Date.now();
    }
    TouchDetector.prototype.init = function (context, callback) {
        this.$el = $(context);
        this.callback = callback;
        $(document).on('touchstart touchend', this.onTouchStart.bind(this));
        $(document).on('mousemove', this.onMouseMove.bind(this));
        this.callback(this.touch);
    };
    TouchDetector.prototype.onMouseMove = function () {
        if (Date.now() - this.lastTouch > 500 && this.touch) {
            this.touch = false;
            this.callback(this.touch);
        }
    };
    TouchDetector.prototype.onTouchStart = function () {
        // filter emulated events coming from touch events
        if (Date.now() - this.lastTouch > 500 && !this.touch) {
            this.touch = true;
            this.callback(this.touch);
        }
        this.lastTouch = Date.now();
    };
    return TouchDetector;
}());
exports.TouchDetector = TouchDetector;
exports.default = angular.module('pb.touchDetector', [])
    .service('touchDetector', TouchDetector);
